var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveSlotIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86864 8L4.60592 5.73728L5.73728 4.60592L8 6.86864L10.2627 4.60592L11.3941 5.73728L9.13136 8L11.3941 10.2627L10.2627 11.3941L8 9.13136L5.73728 11.3941L4.60592 10.2627L6.86864 8ZM13.6568 13.6568C10.5326 16.7811 5.46745 16.7811 2.34319 13.6568C-0.781064 10.5326 -0.781064 5.46745 2.34319 2.34319C5.46745 -0.781064 10.5326 -0.781064 13.6568 2.34319C16.7811 5.46745 16.7811 10.5326 13.6568 13.6568ZM12.5254 12.5254C13.7257 11.3252 14.3999 9.69737 14.3999 8C14.3999 6.30263 13.7257 4.67478 12.5254 3.47455C11.3252 2.27433 9.69737 1.60005 8 1.60005C6.30263 1.60005 4.67478 2.27433 3.47455 3.47455C2.27433 4.67478 1.60005 6.30263 1.60005 8C1.60005 9.69737 2.27433 11.3252 3.47455 12.5254C4.67478 13.7257 6.30263 14.3999 8 14.3999C9.69737 14.3999 11.3252 13.7257 12.5254 12.5254Z",
    fill: "#999999"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveSlotIcon);
export default __webpack_public_path__ + "static/media/remove-slot-icon.aea882ab9750544d6f01a38bbf4aa4fc.svg";
export { ForwardRef as ReactComponent };